'use client';

import type { FC } from 'react';
import { useCapability } from '../../runtime/useCapability';
import { useIsAuthed } from '../../hooks/useIsAuthed';
import { useSupportSummary } from '../../queries/useSupportQueries';
import { useSupportChatStore } from '../../stores/supportChatStore';
import { SupportChatPanel } from './SupportChatPanel';
import { SupportLauncher } from './SupportLauncher';

const SupportWidgetInner: FC = () => {
  const isOpen = useSupportChatStore((state) => state.isOpen);
  const open = useSupportChatStore((state) => state.open);
  const close = useSupportChatStore((state) => state.close);
  const { data: summary } = useSupportSummary(isOpen);

  return (
    <>
      {!isOpen && <SupportLauncher unreadCount={summary?.unreadCount} onOpen={open} />}
      {isOpen && <SupportChatPanel summary={summary} onClose={close} />}
    </>
  );
};

export const SupportWidget: FC = () => {
  const hasSupportChat = useCapability('supportChatWidget');
  const isAuthed = useIsAuthed();

  if (!hasSupportChat || !isAuthed) return null;
  return <SupportWidgetInner />;
};
